export default "__VITE_ASSET__BcoGOHWB__"